import { CALCULATE_PRICE, ADD_FILES, CHANGE_CURRENCY, UPDATE_WORDCOUNT, PRICE_REFRESH_START, PRICE_REFRESH_END, 
	UPDATE_PAGECOUNT, REMOVE_FILES, SET_LANG } from '../constants'

const initialState = {
	price: 0,
	items: [],
	qty: {},
	currency: "EUR",
	files: [],
	priceRefresh: 0,
	shippingAddressFilled: false,
	lang: 'en'
}

const davronReducer = (state = initialState, action) => {
	let currency, index;
	switch (action.type) {
		case CALCULATE_PRICE:
			return Object.assign({}, state, action.payload);

		case ADD_FILES:
			return { 
				...state,
				files: [...state.files, action.payload]
			}

		case REMOVE_FILES:
			index = state.files.find(f => f.handle === action.payload)
			return { 
				...state,
				files: [...state.files.filter(f => f !== index)]
			}

		case CHANGE_CURRENCY:
			return Object.assign({}, state, {currency: currency});

		case UPDATE_WORDCOUNT:
			index = state.files.find(f => f.handle === action.payload.dataName)
			
			return { ...state, files: [ ...state.files.filter(f => f !== index), { ...index, words: action.payload.dataValue } ] };
		
		case UPDATE_PAGECOUNT:
			index = state.files.find(f => f.handle === action.payload.dataName)
			
			return { ...state, files: [ ...state.files.filter(f => f !== index), { ...index, pages: action.payload.dataValue } ] };

		case PRICE_REFRESH_START:
			return Object.assign({}, state, {priceRefresh: 1});

		case PRICE_REFRESH_END:
			return Object.assign({}, state, {priceRefresh: 0});

		case SET_LANG:
			return Object.assign({}, state, {lang: action.payload});

		default:
			return state
	}
}
export default davronReducer


// WEBPACK FOOTER //
// ./src/reducers/davronReducer.js